import aboutUs from "../../assets/images/about-us.gif"
import { Service } from "./Service"
import { Brain, LibraryBig, ListTodo, MessageCircleMore } from "lucide-react"

const services = [

  {
  icon: LibraryBig,
  title: "Các khóa học chất lượng",
  description: "Mỗi khóa học ở Easy English đều được đầu tư kỹ lưỡng và có cách tiếp cận vô cùng đơn giản phù hợp mọi trình độ!"
  },
  {
  icon: ListTodo,
  title: "Đa dạng bài tập",
  description: "Bài tập phủ rộng 4 kỹ năng giúp người học rèn luyện tối ưu"
  },
  {
  icon: Brain,
  title: "Tích hợp AI chấm điểm",
  description: "AI thông minh đánh giá chính xác phát âm, ngữ pháp và kỹ năng viết, giúp người học nhận phản hồi ngay lập tức và cải thiện nhanh chóng."
  },
  {
  icon: MessageCircleMore,
  title: "Đội ngũ hỗ trợ nhiệt tình",
  description: "Hơn ai hết, chúng tôi hiểu những vướng mắc khi học tiếng Anh! Hãy liên hệ ngay để nhận được sự hỗ trợ nhiệt tình từ nhân viên."
  }
  ]
export default function About () {
  return (
    <div className="space-y-8">
      <h1 className="font-[Phudu] font-bold text-center text-2xl">VỀ CHÚNG TÔI</h1>
      <div className="lg:grid grid-cols-2">
          <div className="w-full flex justify-center">
          <img src={aboutUs} className="hidden lg:block lg:w-1/2" alt="About-us"/>
          </div>
          <div className="space-y-4">
            <p>Chào mừng bạn đến với <span className="text-primary font-bold">Easy English</span>, nền tảng hoàn hảo giúp bạn thành thạo tiếng Anh một cách vui nhộn, tương tác và hiệu quả! Chúng tôi tin rằng việc học tiếng Anh nên dễ tiếp cận với mọi người, bất kể độ tuổi, xuất thân hay trình độ hiện tại. Sứ mệnh của chúng tôi là biến quá trình học ngôn ngữ trở nên thu hút, thực tế và phù hợp với nhu cầu của từng học viên.</p>

            <p className="font-bold">Tại Easy English, chúng tôi có:</p>
            <div className="grid md:grid-cols-2 gap-4">
              {services.map(service => (
                <Service icon={service.icon} title={service.title} description={service.description}/>
              ))}

            </div>
          </div>

      </div>
    </div>
  )
}
